import { isNil } from "lodash";
import { HaaiError } from "../models/HaaiError";

export function isHaaiError(obj: any): obj is HaaiError {
  return obj 
    && typeof obj === 'object'
    && (typeof obj.traceId === 'string' || isNil(obj.traceId))
    && (typeof obj.result === 'string' || isNil(obj.traceId))
    && (typeof obj.path === 'string' || isNil(obj.traceId))
    && (typeof obj.code === 'string' || isNil(obj.traceId));
}
